export default __webpack_public_path__ + "media/images/features/toyono/toyonon-5fde63724128665cf062a17ddd59c8e0.png";